import { isNil } from '@lucidlink/tscore';
import { Logging } from '#common/logging';
import { InvalidStateError } from '#common/types';
import { SettingName, SettingTarget } from '#config/types';
export const createSasConfigFetcher = (configManager) => {
    return new SasConfigFetcherImpl(configManager);
};
class SasConfigFetcherImpl {
    configManager;
    log = Logging.getLogger('AzureSasTokenBlobClientProvider');
    constructor(configManager) {
        this.configManager = configManager;
    }
    async fetchSasConfig() {
        const sasConfig = await this.configManager.get([
            {
                target: SettingTarget.FS_CONFIG,
                name: SettingName.ACCESS_TOKEN_CONFIG,
            },
        ]);
        const globalValue = sasConfig[0].global();
        if (isNil(globalValue)) {
            this.log.warn('Failed to fetch azure store SAS config');
            throw new InvalidStateError('Missing SAS config');
        }
        const sasConfigValue = globalValue.asMultiString();
        if (sasConfigValue.length !== 2) {
            this.log.warn('Fetched invalid SAS config');
            throw new InvalidStateError('Invalid SAS config');
        }
        return {
            accessKey: sasConfigValue[0],
            sasToken: sasConfigValue[1],
        };
    }
}
